import { MICROSOFT_OAUTH_URL } from '@mm/api-routes';
import AuthenticatedController from './AuthenticatedController';

export default class MicrosoftController extends AuthenticatedController {
  static async getOauthUrl(facebookPageId: number) {
    return super.get(MICROSOFT_OAUTH_URL, {
      facebook_page_id: facebookPageId,
    });
  }
}
